'use strict';

(function () {
  'use strict';

  angular.module('vnext').controller('SettingsCtrl', SettingsCtrl);

  SettingsCtrl.$inject = ['providerSvc', 'components', 'user', 'pane'];

  function SettingsCtrl(providerSvc, components, user, pane) {
    var vm = this;
    vm.title = 'SettingsCtrl';
    vm.navigatePane = navigatePane;
    vm.pane = pane;

    function navigatePane(state) {
      vm.pane = state;
    }
  }
})();